import React, { FC } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Message } from "rsuite";
import { Button } from "@shared/components";
import { selectors as sharedSelectors } from "@shared/store";
import { selectors as AuthSelectors, actions as AuthActions } from "@containers/Auth/store";
import { ReactComponent as ImpersonateSvg } from "@assets/files/icons/general/impersonate.svg";
import "./ImpersonationInfo.scss";

const MessageComponent = () => {
  const user = useSelector(sharedSelectors.getUserDetails());
  const dispatch = useDispatch();

  const handleImpersonationExit = () => {
    dispatch(AuthActions.impersonationExit.request());
  };

  return (
    <Message type="info">
      <ImpersonateSvg className="collapsed-icon" onClick={handleImpersonationExit} />
      <div className="not-collapsed">
        <span>
          Impersonate Mode
          <br />
          as{" "}
          <b>
            {user?.first_name} {user?.last_name}
          </b>
        </span>
        <Button buttonStyle="royal-blue" className="logout-button" onClick={handleImpersonationExit}>
          Log Out
        </Button>
      </div>
    </Message>
  );
};

export const ImpersonationInfo: FC = () => {
  const isImpersonated = useSelector(AuthSelectors.impersonated());
  const user = useSelector(sharedSelectors.getUserDetails());

  if (!isImpersonated || !user) return null;

  return (
    <div className="impersonation-info">
      <MessageComponent />
    </div>
  );
};
